{
  "satis_urun_komisyon": {
    "Baslik": "Product Commissies",
    "Unvan": "Titel",
    "Min Tutar": "Min Bedrag",
    "Max Tutar": "Max Bedrag",
    "Komisyon": "Commissie",
    "Komisyon SM": "Commissie SM",
    "Durum": "Status",
    "Ekle": "Commissie Toevoegen",
    "Duzenle": "Bewerken",
    "Sil": "Verwijderen",
    "Kaydet": "Opslaan",
    "Guncelle": "Bijwerken",
    "Vazgec": "Annuleren",
    "Aktif": "Actief",
    "Pasif": "Passief",
    "Islemler": "İşlemler",
    "Yenile": "Yenile",
    "Urun": "Ürün"
  }
}
